import { alpha, Stack, styled } from '@ltvco/refresh-lib/theme';

export const CTAOuter = styled(Stack)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  padding: 2,
  backgroundColor: alpha(theme.palette.primary.main, 0.04),
  border: `1px solid ${theme.palette.primary.main}`,
  cursor: 'pointer',
  '&:focus-visible': {
    outline: `3px solid rgba(135, 54, 193, 0.35)`,
    outlineOffset: 2,
  },
}));

export const CTAInner = styled(Stack)(({ theme }) => ({
  width: '100%',
  borderRadius: theme.spacing(2),
  padding: theme.spacing(2.5),
  gap: theme.spacing(1.25),
  flexDirection: 'row',
  alignItems: 'flex-start',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
  },
}));

export const CTAContent = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1),
  flex: 1,
}));
